import Repository from "../Repository";

const resource = "/product/neck-brace";
export default {
  /**
   * Get minerva
   * @param {String} minerva_uuid
   */
  async get(minerva_uuid) {
    return Repository.get(`${resource}/${minerva_uuid}`);
  },

  async createMinerva(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
